import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./BookingModal.css";

function BookingModal({ isOpen, onClose }) {
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);
  const previousFocusRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // Spremi element koji je imao focus prije otvaranja modala
      previousFocusRef.current = document.activeElement;

      // Blokiraj scroll na body
      document.body.style.overflow = "hidden";

      // Fokusiraj close button nakon što se modal otvori
      setTimeout(() => {
        closeButtonRef.current?.focus();
      }, 100);

      // ESC key handler
      const handleEscape = (e) => {
        if (e.key === "Escape") {
          onClose();
        }
      };

      document.addEventListener("keydown", handleEscape);

      return () => {
        document.removeEventListener("keydown", handleEscape);
        document.body.style.overflow = "unset";

        // Vrati focus na prethodni element
        if (previousFocusRef.current) {
          previousFocusRef.current.focus();
        }
      };
    }
  }, [isOpen, onClose]);

  // Focus trap - zadrži focus unutar modala
  useEffect(() => {
    if (!isOpen || !modalRef.current) return;

    const modal = modalRef.current;
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    const handleTab = (e) => {
      if (e.key !== "Tab") return;

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    };

    modal.addEventListener("keydown", handleTab);
    return () => modal.removeEventListener("keydown", handleTab);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
      >
        <button
          className="modal-close"
          onClick={onClose}
          ref={closeButtonRef}
          aria-label="Zatvori prozor rezervacije"
          type="button"
        >
          <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
        </button>

        <div className="modal-header">
          <h2 id="modal-title">Rezerviraj termin</h2>
          <p id="modal-description">Odaberi datum i vrijeme za radionicu</p>
        </div>

        <div className="modal-body">
          <iframe
            src="https://calendar.app.google/1ccEmZZBzTpTpiJDA"
            width="100%"
            height="600"
            frameBorder="0"
            title="Google kalendar rezervacija - odaberite datum i vrijeme"
            aria-label="Google kalendar za rezervaciju termina radionice"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default BookingModal;
